import { Cell } from '@table-library/react-table-library/table';

export const COLUMNS = ({ openModal, t }) => [
    {
        label: t('user_domains.table.domain_name'),
        key: 'domain_name',
        data: 'domain_name',
        Component: Cell,
    },
    {
        label: t('user_domains.table.best_translation'),
        key: 'best_translation',
        data: 'best_translation',
        info: t('user_domains.table.best_translation_info'),
        Component: Cell,
    },
    {
        label: t('user_domains.table.branded_terms'),
        key: 'branded_terms',
        data: 'branded_terms',
        info: t('user_domains.table.branded_terms_info'),
        Component: Cell,
    },
    {
        label: t('user_domains.table.evergreen_weeks'),
        key: 'evergreen_weeks',
        data: 'evergreen_weeks',
        info: t('user_domains.table.evergreen_weeks_info'),
        Component: Cell,
    },
    {
        label: t('user_domains.table.questions_translation'),
        key: 'questions',
        data: 'questions',
        Component: Cell,
    },
    {
        label: t('user_domains.table.device'),
        key: 'device',
        data: 'device',
        info: t('user_domains.table.device_info'),
        Component: Cell,
    },
    {
        label: 'Article Id Position',
        key: 'article_id_position',
        data: 'article_id_position',
        Component: Cell,
    },
    {
        label: t('user_domains.table.action'),
        key: 'action',
        data: 'action',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return null;
            return (
                <button
                    type="button"
                    className="button button-filled button-primary button-icon"
                    id="name-edit-btn"
                    onClick={() => openModal(item)}
                    title={t('user_domains.table.edit')}
                >
                    <i className="icon-edit"></i>
                </button>
            );
        },
    },
];
